import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';

// QueryClient configuration adapted from mobile app for admin use
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Balanced caching for admin data
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      gcTime: 30 * 60 * 1000, // 30 minutes - cache garbage collection time

      // Retry configuration optimized for admin dashboard
      retry: (failureCount, error: Error) => {
        // Don't retry on 4xx errors (client errors)
        if (
          'response' in error &&
          typeof error.response === 'object' &&
          error.response !== null
        ) {
          const response = error.response as { status?: number };
          if (
            response.status &&
            response.status >= 400 &&
            response.status < 500
          ) {
            return false;
          }
        }

        // Retry up to 2 times for network errors
        return failureCount < 2;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 5000),

      // Network mode for web admin
      networkMode: 'online',

      // Refetch configuration for admin dashboard
      refetchOnWindowFocus: false, // Don't refetch when switching browser tabs
      refetchOnReconnect: true, // Refetch when network reconnects
      refetchOnMount: 'always', // Always refetch on component mount for fresh data
    },
    mutations: {
      retry: false, // Don't retry mutations automatically
      networkMode: 'online',
    },
  },
});

export const QueryProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
